import { ModelHelper } from '../classes/model-helper';

export class Language {
	code: string;
	name: string;
	displayName: string;

	/**
	 *
	 *
	 * Static mapping function
	 *
	 *
	 *
	 * @param data
	 * @param item
	 * @returns Language
	 */
	static map(data: any, item: Language = new Language()): Language {
		return item.map(data);
	}

	/**
	 *
	 *
	 * Non static mapping function
	 *
	 *
	 *
	 * @param data
	 * @return Language
	 */
	public map(data: any): Language {
		ModelHelper.map(data, this, 'code');
		ModelHelper.map(data, this, 'name');
		ModelHelper.map(data, this, 'displayName');

		return this;
	}

	/**
	 * Prepare data for API
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		return { code: data.code };
	}
}
